/*
  Centralized formatters for the app.
  Usage:
    import { toPersianDigits, formatCurrency, formatJalaliDate } from '@/utils/formatters';
*/
import moment from 'jalali-moment';

export function toPersianDigits(str) {
  if (str === null || str === undefined) return '';
  const persian = {
    0: '۰', 1: '۱', 2: '۲', 3: '۳', 4: '۴', 5: '۵', 6: '۶', 7: '۷', 8: '۸', 9: '۹'
  };
  return String(str).replace(/\d/g, (d) => persian[d]);
}

export function formatCurrency(v, suffix = ' ریال') {
  if (v == null) return '-';
  const n = Number(v);
  if (Number.isNaN(n)) return v;
  // keep group delimiter as comma (english digits) then convert digits
  const withCommas = n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return toPersianDigits(withCommas) + suffix;
}

export function formatJalaliDate(gregorianDate) {
  if (!gregorianDate || gregorianDate === '0000-00-00') return 'ثبت نشده';
  if (moment(gregorianDate, 'YYYY-MM-DD').isValid()) {
    return toPersianDigits(moment(gregorianDate, 'YYYY-MM-DD').format('jYYYY/jMM/jDD'));
  }
  return gregorianDate;
}

export default { toPersianDigits, formatCurrency, formatJalaliDate };
